import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { dispatchGlobalError } from '../../utils/globalMessageEvents';

export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    dispatchGlobalError(error?.message || 'An unexpected error occurred', {
      source: 'react',
      stack: error?.stack,
      componentStack: info?.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ py: 4, px: 2, maxWidth: 560 }}>
          <Typography variant="h6" gutterBottom>
            This screen hit an error
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            A red banner at the top keeps the technical details so you can log a ticket or copy
            them. You can go back to the dashboard or retry after we deploy a fix.
          </Typography>
          <Button variant="contained" onClick={() => this.props.onReset?.()} sx={{ mr: 1 }}>
            Try again
          </Button>
          <Button variant="outlined" component={Link} to="/dashboard">
            Dashboard
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}
